module.exports = __webpack_public_path__ + "media/fonts/ProximaNova-Semibold-c8fea5d9.woff2";